import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchSubleaseSettingsRequested } from 'Modules/Boardwork/Tasks/Sublease/shared/store/sublease'
import { COMMITTEES_RESET } from 'Modules/HousingAssociation/BoardAndCommittees/shared/store/committees/actionTypes'
import { LOCAL_STORAGE_CLIENT_ID } from 'shared/constants/localStorageVariables'
import { BOARD_FETCH_REQUESTED } from '../board/actionTypes'
import terminologyApi from '../terminology/terminology.service'
import clientsApi from './clients.service'
import { setActiveClientIdStarted, setActiveClientId } from '.'
import { emptySplitApi } from '../store'
import menuApi from '../menu/menu.service'
import loanApi from '../economy/loan/loan.service'
import { resetBudgetState } from 'Modules/Economy/Budget/shared/store/budgetSlice'

export const setClientById = createAsyncThunk<void, string | undefined>(
  'clients/setClientById',
  async (clientId, { dispatch }) => {
    if (!clientId) return

    const createAction = (type: string) => ({ type, payload: clientId })

    dispatch(setActiveClientIdStarted())

    await localStorage.setItem(LOCAL_STORAGE_CLIENT_ID, clientId)

    await dispatch(menuApi.endpoints.getMenu.initiate(clientId))

    dispatch(createAction(BOARD_FETCH_REQUESTED))
    dispatch(createAction(COMMITTEES_RESET))

    dispatch(loanApi.endpoints.getPendingInterestRateChanges.initiate(clientId))
    dispatch(terminologyApi.endpoints.getTerminology.initiate(clientId))

    dispatch(fetchSubleaseSettingsRequested(clientId))

    await dispatch(clientsApi.endpoints.getClient.initiate(clientId))

    dispatch(setActiveClientId(clientId))
    dispatch(resetBudgetState())

    dispatch(emptySplitApi.util.resetApiState())
  }
)
